import { faFilePen, faPlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Button, Dialog, Grid, TextField, Toolbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { useAuth } from '../../units/auth/AuthProvider';

export const useEditStoreDialog = () => {
    const classes = useStyles();
    const auth = useAuth();
    const [open, setOpen] = useState(false);
    const [storeId, setStoreId] = useState('');
    const [inputStoreName, setInputStoreName] = useState('');
    const [editMode, setEditMode] = useState<'create' | 'update'>('create');
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);
    const [onCreateStore, setOnCreateStore] = useState<(storeName: string) => void>(() => () => {});
    const [onUpdateStore, setOnUpdateStore] = useState<(storeId: string, storeName: string) => void>(() => () => {});
    const onReset = () => {
        setStoreId('');
        setInputStoreName('');
    };
    useEffect(() => {
        if (!open) onReset();
    }, [open]);
    useEffect(() => {
        storeId.length > 0 ? setEditMode('update') : setEditMode('create');
    }, [storeId]);
    return {
        classes,
        auth,
        alert,
        open,
        setOpen,
        storeId,
        setStoreId,
        inputStoreName,
        setInputStoreName,
        editMode,
        setEditMode,
        onOpen,
        onClose,
        onCreateStore,
        setOnCreateStore,
        onUpdateStore,
        setOnUpdateStore,
        onReset,
    };
};

export interface EditStoreDialogProps extends ReturnType<typeof useEditStoreDialog> {}

export const EditStoreDialog = (props: EditStoreDialogProps): React.ReactElement => {
    return (
        <Dialog fullWidth={true} maxWidth={'lg'} open={props.open} onClose={props.onClose}>
            <AppBar position='sticky' className={props.classes.appBar} color='primary'>
                <Toolbar>
                    <Typography style={{ width: '100%', textAlign: 'center' }} variant='h4' component={'div'}>
                        {props.storeId.length > 0 ? '更新使用者' : '新增使用者'}
                    </Typography>
                    <Typography style={{ position: 'absolute', right: '0px' }} variant='h4' component={'div'}>
                        <Button color='inherit' onClick={props.onClose}>
                            <Typography variant='h5'>
                                <FontAwesomeIcon icon={faXmark} size='lg' fixedWidth />
                            </Typography>
                        </Button>
                    </Typography>
                </Toolbar>
            </AppBar>
            <Grid container flexDirection={'column'} padding={4}>
                <Grid container item flexDirection={'row'}>
                    <Grid container item flexDirection={'row'} xs={12}>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputStoreName}
                                onChange={(e) => props.setInputStoreName(e.target.value)}
                                variant='outlined'
                                label={
                                    <>
                                        <span style={{ color: 'red' }}>*</span>
                                        {'店面名稱'}
                                    </>
                                }
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} justifyContent={'flex-end'} xs={12}>
                            {props.editMode == 'create' ? (
                                <Button
                                    disabled={![props.inputStoreName.length > 0].every((v) => v)}
                                    className={props.classes.buttonCyan}
                                    style={{ margin: 4, marginTop: 12 }}
                                    onClick={() => {
                                        if (typeof props.onCreateStore == 'function') props.onCreateStore(props.inputStoreName);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faPlus} fixedWidth />
                                    {'確定新增'}
                                </Button>
                            ) : (
                                <Button
                                    disabled={![props.inputStoreName.length > 0].every((v) => v)}
                                    className={props.classes.buttonCyan}
                                    style={{ margin: 4, marginTop: 12 }}
                                    onClick={() => {
                                        if (typeof props.onUpdateStore == 'function')
                                            props.onUpdateStore(props.storeId, props.inputStoreName);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePen} fixedWidth />
                                    {'確定更新'}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};
